import script from "./FacilityDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./FacilityDetailsView.vue?vue&type=style&index=0&id=581622a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581622a9"]])

export default __exports__